"use client";

import { IFilterablePaginatedSection } from "@faire/web-api/indigofair/data/IFilterablePaginatedSection";
import React from "react";

import { SDUISectionInstanceRendererProps } from "@faire/retailer/components/SDUI/__internal__/types";
import { FilterablePaginatedSectionComponentsColumnRenderer } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Components/FilterablePaginatedSectionComponentsColumnRenderer";
import { useFilterablePaginatedSectionQuery } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Fetching/useFilterablePaginatedSectionQuery";
import { hubComponentRenderers } from "@faire/retailer/views/category/HubsRSC/utils/hubComponentRenderers";

export const SDUIFilterablePaginatedSectionComponentsColumnNonRSC: React.FC<
  Omit<SDUISectionInstanceRendererProps, "section"> & {
    filterablePaginatedSection: IFilterablePaginatedSection;
  }
> = ({
  filterablePaginatedSection,
  componentRenderers,
  sectionLoggingData,
}) => {
  const {
    isFilterLoading,
    isFilteredComponentsFetching,
    filteredComponentsData,
    isFilteredComponentsError,
  } = useFilterablePaginatedSectionQuery(filterablePaginatedSection);

  return (
    <FilterablePaginatedSectionComponentsColumnRenderer
      filteredComponentsData={filteredComponentsData}
      isFilterLoading={isFilterLoading}
      isFilteredComponentsFetching={isFilteredComponentsFetching}
      componentRenderers={getComponentRenderers(componentRenderers)}
      sectionLoggingData={sectionLoggingData}
      isFilteredComponentsError={isFilteredComponentsError}
    />
  );
};

/**
 * This is a temporary fix since we cannot pass functions from the server to the FPS section renderer
 * (which is a client component)
 * This will be removed once we migrate FPS to RSC
 * see HubsViewLayoutRendererRSC.tsx for the other half of this
 */
const getComponentRenderers = (
  componentRenderers: SDUISectionInstanceRendererProps["componentRenderers"]
) => {
  return Object.keys(componentRenderers).length > 0
    ? componentRenderers
    : hubComponentRenderers;
};
